import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { SelectItem } from 'primeng/api';
import { WsdefsService } from '../../../../../../../core/repositories/wsdefs.service'
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';
import { Wsdefs } from '../../../../../../../core/entities/wsdefs.model';
import { Typeruns } from '../../../../../../../core/entities/typeruns.model';
import { Xmldefs } from '../../../../../../../core/entities/xmldefs.model';
import { Setvalues } from '../../../../../../../core/entities/setvalues.model';
import { Typefinders } from '../../../../../../../core/entities/typefinders.model';
import { ONLINE_OPTIONS, BOOLEAN_OPTION, VIEW_OPTION } from '../../../../../../../core/utils/constants';

@Injectable()
export class EditDialogsWsdefsService {

  wsdefs: Wsdefs = new Wsdefs();
  originalWsdefs: Wsdefs = new Wsdefs();
  parametersInput: Wsdefs = new Wsdefs();

  onlineOption: any[] = ONLINE_OPTIONS;
  boolOption: any[] = BOOLEAN_OPTION;
  viewOption: any[] = VIEW_OPTION;

  optionsTipos: SelectItem[] = [];
  optionsXmls: SelectItem[] = [];
  optionsValues: SelectItem[] = [];
  optionsFinders: SelectItem[] = [];

  optionsTipoBase: SelectItem[] = [];
  optionsXmlBase: SelectItem[] = [];
  optionsValuesBase: SelectItem[] = [];
  optionsFindersBase: SelectItem[] = [];

  changetitulo: boolean = false;

  tipos: Typeruns[] = new Array<Typeruns>();
  xmls: Xmldefs[] = new Array<Xmldefs>();
  setvalues: Setvalues[] = new Array<Setvalues>();
  typefinders: Typefinders[] = new Array<Typefinders>();

  constructor(private wsdefsService: WsdefsService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.wsdefs = data.wsdefs;
    this.changetitulo = data.titulochange;
    this.originalWsdefs = _.cloneDeep(this.wsdefs);
    console.log(data);
    return forkJoin([this.internalHomeService.allTyperuns(),
                    this.internalHomeService.allXmldefs(),
                    this.internalHomeService.allSetvalues(),
                    this.internalHomeService.allTypefinders()]).pipe(map(dataGroup => {
      console.log(dataGroup);

      this.tipos = dataGroup[0];
      this.xmls = dataGroup[1];
      this.setvalues = dataGroup[2];
      this.typefinders = dataGroup[3];

      this.optionsTipoBase.push({value: null, label: ""});
      this.optionsXmlBase.push({value: null, label: ""});
      this.optionsValuesBase.push({value: null, label: ""});
      this.optionsFindersBase.push({value: null, label: ""});

      for(let i = 0; i < this.tipos.length; i++){
        this.optionsTipoBase.push({value: this.tipos[i].code, label: this.tipos[i].code});
      }

      for(let i = 0; i < this.xmls.length; i++){
        this.optionsXmlBase.push({value: this.xmls[i].code, label: this.xmls[i].code});
      }

      for(let i = 0; i < this.setvalues.length; i++){
        this.optionsValuesBase.push({value: this.setvalues[i].code, label: this.setvalues[i].code});
      }

      for(let i = 0; i < this.typefinders.length; i++){
        this.optionsFindersBase.push({value: this.typefinders[i].code, label: this.typefinders[i].code});
      }

      this.optionsTipos = this.optionsTipoBase;
      this.optionsXmls = this.optionsXmlBase;
      this.optionsValues = this.optionsValuesBase;
      this.optionsFinders = this.optionsFindersBase;

      if (Utils.noUndfAndNull(data.wsdefs)) {
        this.wsdefs = _.cloneDeep(data.wsdefs);
      }

      this.optionsTipoBase = [];
      this.optionsXmlBase = [];
      this.optionsValuesBase = [];
      this.optionsFindersBase = [];

      return true;
    }));
  }

  /**
  * @description
  * Guarda el wsdef
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.wsdefs.id, "")) {

      /*comparamos el wsdef original con el modificado*/
      let compareWsdef = this.compare(this.wsdefs, this.originalWsdefs);

      if(compareWsdef){
        return of(-1);
      }else{
        this.anadirIdObjetosCombo();
        return this.wsdefsService.postWsdef(this.wsdefs);
      }

    }else{
      this.anadirIdObjetosCombo();
      return this.wsdefsService.postWsdef(this.wsdefs);
    }
  }

  /**
  * @description
  * Comprueba si dos Wsdefs son iguales.
  * @param datoX Wsdef 1
  * @param datoY Wsdef 2
  * @returns True si son iguales
  */
  public compare(itemX:Wsdefs, itemY:Wsdefs):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.online !== null) {
        let value = itemX.online.toString();
        if (value === 'null') {
          itemX.online = 0;
        }
      }
      if (itemX.enable !== null) {
        let value = itemX.enable.toString();
        if (value === 'null') {
          itemX.enable = 0;
        }
      }
      if (itemX.filterenabled !== null) {
        let value = itemX.filterenabled.toString();
        if (value === 'null') {
          itemX.filterenabled = 0;
        }
      }
      if (itemX.paginateenabled !== null) {
        let value = itemX.paginateenabled.toString();
        if (value === 'null') {
          itemX.paginateenabled = 0;
        }
      }
      if (itemX.quickview !== null) {
        let value = itemX.quickview.toString();
        if (value === 'null') {
          itemX.quickview = 0;
        }
      }
      if (itemX.typerun.code !== null) {
        let value = itemX.typerun.code.toString();
        if (value === 'null') {
          itemX.typerun.code = "";
        }
      }
      if (itemX.xmldef.code !== null) {
        let value = itemX.xmldef.code.toString();
        if (value === 'null') {
          itemX.xmldef.code = "";
        }
      }
      if (itemX.setvalue.code !== null) {
        let value = itemX.setvalue.code.toString();
        if (value === 'null') {
          itemX.setvalue.code = "";
        }
      }
      if (itemX.typefinder.code !== null) {
        let value = itemX.typefinder.code.toString();
        if (value === 'null') {
          itemX.typefinder.code = "";
        }
      }

      if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
      || !Utils.compareTextOrNumber(itemX.desc, itemY.desc)
      || !Utils.compareTextOrNumber(itemX.url, itemY.url)
      || !Utils.compareTextOrNumber(itemX.xmlin, itemY.xmlin)
      || !Utils.compareTextOrNumber(itemX.numorder, itemY.numorder)
      || !Utils.compareTextOrNumber(itemX.online, itemY.online)
      || !Utils.compareTextOrNumber(itemX.enable, itemY.enable)
      || !Utils.compareTextOrNumber(itemX.filterenabled, itemY.filterenabled)
      || !Utils.compareTextOrNumber(itemX.paginateenabled, itemY.paginateenabled)
      || !Utils.compareTextOrNumber(itemX.quickview, itemY.quickview)
      || !Utils.compareTextOrNumber(itemX.typerun.code, itemY.typerun.code)
      || !Utils.compareTextOrNumber(itemX.xmldef.code, itemY.xmldef.code)
      || !Utils.compareTextOrNumber(itemX.setvalue.code, itemY.setvalue.code)
      || !Utils.compareTextOrNumber(itemX.typefinder.code, itemY.typefinder.code)
      || !Utils.compareTextOrNumber(itemX.cat, itemY.cat)
      || !Utils.compareTextOrNumber(itemX.esp, itemY.esp))
      && (itemX.code !== ""
      && Utils.noUndfAndNull(itemX.online)
      && Utils.noUndfAndNull(itemX.enable)
      && Utils.noUndfAndNull(itemX.filterenabled)
      && Utils.noUndfAndNull(itemX.paginateenabled)
      && Utils.noUndfAndNull(itemX.quickview)
      && (Utils.noUndfAndNull(itemX.typerun.code) && itemX.typerun.code !== "")
      && (Utils.noUndfAndNull(itemX.xmldef.code) && itemX.xmldef.code !== "")
      && (Utils.noUndfAndNull(itemX.setvalue.code) && itemX.setvalue.code !== "")
      && (Utils.noUndfAndNull(itemX.typefinder.code) && itemX.typefinder.code !== "")))
        return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Nos traemos por medio del Code de los combos los Id para así referenciar su objeto correspondiente
  */
  public anadirIdObjetosCombo(){
    for(let i = 0; i < this.tipos.length; i++){
      if(this.wsdefs.typerun.code === this.tipos[i].code){
        this.wsdefs.typerun.id = this.tipos[i].id;
      }
    }
    for(let i = 0; i < this.xmls.length; i++){
      if(this.wsdefs.xmldef.code === this.xmls[i].code){
        this.wsdefs.xmldef.id = this.xmls[i].id;
      }
    }
    for(let i = 0; i < this.setvalues.length; i++){
      if(this.wsdefs.setvalue.code === this.setvalues[i].code){
        this.wsdefs.setvalue.id = this.setvalues[i].id;
      }
    }
    for(let i = 0; i < this.typefinders.length; i++){
      if(this.wsdefs.typefinder.code === this.typefinders[i].code){
        this.wsdefs.typefinder.id = this.typefinders[i].id;
      }
    }
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.wsdefs = new Wsdefs();
  }

}
